import React from "react";
import "./UserProfile.css";

const UserProfile = () => {
  return (
    <div className="container-center">
      <div className="container-css">
        <p className="welcome-message">hi there user!</p>
      </div>
    </div>
  );
};

export default UserProfile;
